import React, { useEffect, useState } from "react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  Card,
  CardBody,
  Table,
  Button,
  Dropdown,
} from "react-bootstrap";
import icon1 from "../../assets/authorize-net.svg";
import icon2 from "../../assets/Invoice.svg";
import icon5 from "../../assets/purchase-order.svg";
import { API_ENDPOINTS } from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import {
  IconCircleCheckFilled,
  IconCirclePlusFilled,
  IconMail,
  IconPhone,
  IconUser,
  IconCreditCard,
  IconChevronDown,
  IconEdit,
  IconRefreshDot,
} from "@tabler/icons-react";
import { useFormContext, Controller } from "react-hook-form";
import PhoneInput from "react-phone-number-input";
import "./CreateLifeCycle.css";
import PurchaseOrderPopUp from "./PurchaseOrderPopUp";
import CardDetails from "./CardDetails/CardDetails";
import { useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ComanConfirmationModal from "../../components/ComanConfirmationModal";
function VendorForm({ apiVendor, orderId, onRefresh, status }) {
  const {
    control,
    watch,
    getValues,
    setValue,
    register,
    formState: { errors },
  } = useFormContext();

  const { data: syncedData, postData: syncData } = usePostRequest(
    API_ENDPOINTS.SYNC_QUICK_BOOK,
  );

  const { data: Order, postData: fetchSingleOrder } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_ORDER,
  );

  const { isLoading: isChangingstatus, postData: changeStatus } =
    usePostRequest(API_ENDPOINTS.FINANCE_STATUS_CHANGE);

  const { data: syncedTransaction, postData: syncTransaction } = usePostRequest(
    API_ENDPOINTS.SYNC_TRANSACTIONID,
  );

  const { data: syncedBillPo, postData: syncBILL_PO } = usePostRequest(
    API_ENDPOINTS.SYNC_BILL_PO,
  );

  const [isPurchaseOpen, setIsPurchaseOpen] = useState({
    show: false,
  });
  const { order_id } = useParams();
  const [showCardDetails, setShowCardDetails] = useState(false);
  const openCardDetails = () => setShowCardDetails(true);
  const closeCardDetails = () => setShowCardDetails(false);
  const [poStatus, setPoStatus] = useState({});
  const orderType = watch("ordertype");
  // const vendorPartner = watch("cards");
  const vendorPartner = watch(
    orderType === "CRK" ||
      orderType === "DS" ||
      orderType === "KIT" ||
      orderType === "S"
      ? "cards"
      : "product_sales",
  );
  const order_Payment_Type = watch("order_Payment_Type");
  const aVendors = watch("aVendors");
  console.log("aVendorsaVendors0", aVendors);

  const [isModalStatusOpen, setIsModalStatusOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const KoEmail = watch("contractOfficerEmail");
  const [transactionId, setTransactionId] = useState("");
  const [localApiVendor, setLocalApiVendor] = useState(apiVendor);
  const organization_name = watch("organization_name");
  const [editModes, setEditModes] = useState({
    qb_id: false,
    transaction_id: false,
  });
  const [vendorEditModes, setVendorEditModes] = useState({});
  const user = useSelector((state) => state.auth.user);

  console.log("aVendors in VendorForm", aVendors);
  const canPay = user?.permissions?.manage_payment?.includes("write");

  console.log("statusstatusstatusstatus", status)

  useEffect(() => {
    if (vendorPartner?.length > 0) {
      const existingAVendors = getValues("aVendors") || [];
      const orderVendors = apiVendor?.OrderVendors || [];
      const vendorPartnerNames = new Set(
        vendorPartner.map((v) => v?.vendorPartner?.trim().toLowerCase()),
      );

      // const filteredExistingAVendors = existingAVendors.filter(
      //   (vendor) =>
      //     vendor?.display_name &&
      //     vendorPartnerNames.has(vendor.display_name.trim().toLowerCase()),
      // );

      const filteredExistingAVendors = existingAVendors
        .filter(
          (vendor) =>
            vendor?.display_name &&
            vendorPartnerNames.has(vendor.display_name.trim().toLowerCase()),
        )
        .map((v) => {
          if (v.order_vendor_id) return v;
          const match = orderVendors.find(
            (ov) =>
              ov?.Vendor?.display_name?.trim().toLowerCase() ===
              v.display_name.trim().toLowerCase(),
          );
          return {
            ...v,
            order_vendor_id: match?.id ?? null,
            po_qb_id: v.po_qb_id ?? match?.po_qb_id ?? null,
            bill_qb_id: v.bill_qb_id ?? match?.bill_qb_id ?? null,
            bill_paid: v.bill_paid ?? match?.bill_paid ?? null,
          };
        });

      const existingNames = new Set(
        filteredExistingAVendors.map((v) =>
          v.display_name.trim().toLowerCase(),
        ),
      );

      // Add missing vendors with po_qb_id and bill_qb_id
      const newNames = new Set();
      const newVendors = vendorPartner.reduce((acc, item, index) => {
        const rawName = item?.vendorPartner;
        const name = rawName?.trim().toLowerCase();
        // const orderVendor = orderVendors[index] || {};
        // console.log("OrderVendors:", apiVendor?.OrderVendors);

        const orderVendor =
          orderVendors.find(
            (ov) => ov?.Vendor?.display_name?.trim().toLowerCase() === name,
          ) || {};

        console.log("orderVendor", orderVendor);

        if (name && !existingNames.has(name) && !newNames.has(name)) {
          acc.push({
            display_name: rawName.trim(),
            order_vendor_id: orderVendor?.id ?? null,
            po_qb_id: orderVendor?.po_qb_id ?? null,
            bill_qb_id: orderVendor?.bill_qb_id ?? null,
            bill_paid: orderVendor?.bill_paid ?? null,
          });
          newNames.add(name);
        }
        return acc;
      }, []);
      const merged = [...filteredExistingAVendors, ...newVendors];
      setValue("aVendors", merged);
    } else {
      setValue("aVendors", []);
    }
  }, [vendorPartner, getValues, setValue, apiVendor]);

  const handlePurchase_OPEN = (e) => {
    e.preventDefault();
    // setRfqSku(rfq);
    setIsPurchaseOpen({ show: true });
  };

  useEffect(() => {
    const allowedStatuses = ["PENDING", "IN PROGRESS", "DELIVERED"];

    if (allowedStatuses.includes(status)) {
      syncData({
        order_id: order_id,
        order_payment_type: order_Payment_Type,
      });
    }
  }, []);

  const handleSyncCustomers = () => {
    syncData(
      {
        order_id: orderId,
        order_payment_type: order_Payment_Type,
        button_place: "finance_tab",
      },
      onSyncSuccess,
      onSyncError,
    );
  };

  console.log("apiVendor", apiVendor);

  const onSyncSuccess = (response) => {
    toast.success(response.message || "Synced with QuickBooks successfully");
    // fetchSingleOrder({ order_id, route_name: "edit" }, onSingleOrderSuccess);
    if (onRefresh) {
      onRefresh(); // ← Triggers parent to refetch fresh order → updates apiVendor
    } // setOrderDataFetched(true);
  };

  const onSingleOrderSuccess = (response) => {
    console.log("Fetched Single Order Data after Sync:", response);
    setLocalApiVendor(response?.data || {});
  };

  const onSyncError = (error) => {
    toast.error(error.message || "Failed to sync with QuickBooks");
  };

  const onTransactionSuccess = (response) => {
    toast.success(response.message || "Synced with QuickBooks successfully");
    setValue("transactionId", "");
    setValue("salesreceiptId", "");
    setEditModes({ qb_id: false, transaction_id: false });
    if (onRefresh) {
      onRefresh(); // ← Triggers parent to refetch fresh order → updates apiVendor
    }
  };
  const onTransactionError = (error) => {
    toast.error(error.message || "Failed to sync with QuickBooks");
  };

  const handleSalesReceiptSync = () => {
    const transactionId = getValues("salesreceiptId");

    if (!transactionId) {
      toast.error("Transaction ID is required");
      return;
    }

    syncTransaction(
      {
        amount: apiVendor?.total_cost_after_margin,
        order_id: orderId,
        transaction_id: transactionId,
        type: "qb_id",
      },
      onTransactionSuccess,
      onTransactionError,
    );
  };

  const handleTransactionSync = () => {
    const transactionId = getValues("transactionId");

    if (!transactionId) {
      toast.error("Transaction ID is required");
      return;
    }

    syncTransaction(
      {
        amount: apiVendor?.total_cost_after_margin,
        order_id: orderId,
        transaction_id: transactionId,
        type: "auth_id",
      },
      onTransactionSuccess,
      onTransactionError,
    );
  };

  const handleOtpVerifiedFromCard = (response) => {
    console.log("Final OTP Verified Response (VendorForm):", response);
    // setTransactionId(response?.transactionId || "");
    if (onRefresh) {
      onRefresh(); // ← Triggers parent to refetch fresh order → updates apiVendor
    }
  };

  const handleBillPoSync = (index, type) => {
    const vendor = getValues(`aVendors.${index}`);
    console.log("vendor here", vendor);

    const fieldName = type === "po" ? "poValue" : "billValue";
    const value = getValues(`aVendors.${index}.${fieldName}`);

    if (!value) {
      toast.error(
        `${type === "po" ? "Purchase Order" : "Bill"} ID is required`,
      );
      return;
    }
    if (!vendor?.order_vendor_id) {
      toast.error("Order vendor ID missing");
      return;
    }

    syncBILL_PO(
      {
        order_id: orderId,
        value,
        type,
        order_vendor_id: vendor.order_vendor_id,
      },
      (res) => {
        toast.success(res.message || "Successfully updated");
        setValue(`aVendors.${index}.${fieldName}`, "");
        setVendorEditModes((prev) => ({
          ...prev,
          [index]: { ...(prev[index] || {}), [type]: false },
        }));
        if (onRefresh) onRefresh();
      },
      (err) => toast.error(err.message || "Failed to update"),
    );
  };

  const STATUS_OPTIONS = [
    {
      value: "Not Created",
      label: "Not Created",
      cls: "bg-secondary-lt text-secondary badge-outline",
    },
    {
      value: "Pending",
      label: "Pending",
      cls: "bg-orange-lt text-orange badge-outline",
    },
    {
      value: "Successful",
      label: "Successful",
      cls: "bg-green-lt text-green badge-outline",
    },
  ];

  function StatusBadgeDropdown({ value = "Not Created", onSelect }) {
    const current =
      STATUS_OPTIONS.find((o) => o.value === value) || STATUS_OPTIONS[0];

    return (
      <Dropdown className="d-inline-block">
        <Dropdown.Toggle
          as="span"
          className={`status-pill-toggle badge ${current.cls} d-inline-flex align-items-center gap-1`}
          style={{
            cursor: "pointer",
            borderRadius: "20px",
            padding: "6px 12px",
            fontSize: "0.8125rem",
            fontWeight: 500,
          }}
        >
          {current.label}
          <IconChevronDown size={14} />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {STATUS_OPTIONS.map((opt) => (
            <Dropdown.Item
              key={opt.value}
              active={opt.value === value}
              disabled={opt.value === value}
              onClick={() => opt.value !== value && onSelect?.(opt.value)}
            >
              {opt.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  // 2) Replace existing ChangestatusHandler + openSubstatusModal with these
  const ChangestatusHandler = ({ value, type, order_vendor_id }) => {
    changeStatus(
      {
        order_id: orderId,
        value,
        type,
        order_vendor_id: order_vendor_id ?? null,
      },
      (res) => {
        toast.success(res.message);
        if (onRefresh) onRefresh();
      },
      (error) => {
        toast.error(error.message || "An error occurred during Status Change.");
      },
    );
  };

  const openStatusModal = ({
    value,
    type,
    order_vendor_id = null,
    oldValue,
  }) => {
    setIsModalStatusOpen({
      show: true,
      action: "Change",
      message: `Are you sure you want to change status from "${oldValue}" to "${value}"?`,
      onConfirm: () => ChangestatusHandler({ value, type, order_vendor_id }),
      title: "Change Status",
      icon: <IconRefreshDot stroke={1} />,
      type: "success",
    });
  };

  return (
    <>
      <ComanConfirmationModal
        show={isModalStatusOpen.show}
        onHide={() => {
          setIsModalStatusOpen({ ...isModalStatusOpen, show: false });
        }}
        title={isModalStatusOpen.title}
        message={isModalStatusOpen.message}
        onConfirm={isModalStatusOpen.onConfirm}
        icon={isModalStatusOpen.icon}
        type={isModalStatusOpen.type}
      />

      {isPurchaseOpen.show && (
        <PurchaseOrderPopUp
          show={isPurchaseOpen.show}
          setShow={setIsPurchaseOpen}
        />
      )}

      <CardDetails
        show={showCardDetails}
        onClose={closeCardDetails}
        emailId={KoEmail}
        onOtpVerified={handleOtpVerifiedFromCard}
      />

      {orderId && (
        <div className="d-flex justify-content-end mb-2">
          <Button
            className="ms-2"
            variant="warning"
            onClick={handleSyncCustomers}
          >
            Sync with QuickBooks
          </Button>
        </div>
      )}

      <Card className="mb-4 ">
        <div className="card-header bg-white border-0 d-flex align-items-center gap-2">
          <span
            className="badge border text-secondary fw-normal"
            style={{
              fontSize: "0.75rem",
              padding: "4px 10px",
              background: "#f1f3f5",
              borderColor: "#dee2e6 !important",
              borderRadius: "20px",
            }}
          >
            Customer Documents
          </span>
          <h3 className="card-title mb-0">
            <b>{organization_name || ""}</b>
          </h3>
        </div>
        <div class="mail_wrapper p-0 border-0 mb-0 box-shadow-none">
          <Table className="table-bordered card-table">
            <thead>
              <tr>
                {/* OLD: TYPE / STATUS / ACTION */}
                <th style={{ width: "25%" }}>DOCUMENT</th>
                <th style={{ width: "25" }}>STATUS</th>
                <th style={{ width: "50%" }}>DETAILS</th>
              </tr>
            </thead>
            <tbody>
              {order_Payment_Type === "invoiced" ? (
                <>
                  <tr>
                    <td>Invoice</td>
                    <td>
                      <StatusBadgeDropdown
                        value={apiVendor?.finance_status || "Not Created"}
                        onSelect={(val) =>
                          openStatusModal({
                            value: val,
                            type: "invoice",
                            order_vendor_id: null,
                            oldValue:
                              apiVendor?.finance_status || "Not Created",
                          })
                        }
                      />
                    </td>
                    {/* <td>
                      <span
                        className={`${
                          apiVendor?.qb_id?.trim()
                            ? "badge bg-green text-green-fg"
                            : "badge bg-secondary text-white me-2"
                        }`}
                      >
                        <IconCircleCheckFilled size={12} />
                        {apiVendor?.qb_id?.trim()
                          ? "Successful ▾"
                          : "Not Created ▾"}
                      </span>

                      <span
                        className={`${
                          apiVendor?.customer_paid === "paid"
                            ? "badge bg-green text-green-fg"
                            : "badge bg-orange text-orange-fg"
                        }`}
                      >
                        <IconCircleCheckFilled size={12} />
                        {apiVendor?.customer_paid === "paid"
                          ? "Paid ▾"
                          : "Unpaid ▾"}
                      </span>
                    </td> */}
                    <td>
                      <div className="d-flex justify-content-between align-items-center">
                        {(!apiVendor?.qb_id || editModes.qb_id) && orderId && (
                          <div style={{ flex: 1 }}>
                            <div className="d-flex align-items-center gap-4">
                              <Form.Control
                                {...register("salesreceiptId")}
                                placeholder="e.g. 234, 245, 45"
                                className=""
                                autoComplete="off"
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleSalesReceiptSync();
                                  }
                                }}
                              />

                              <div className="d-flex align-items-center ">
                                <div
                                  className={`action-item pe-3 me-2 ${
                                    editModes.qb_id ? "border-end" : ""
                                  }`}
                                >
                                  <a
                                    variant="link"
                                    className="p-0 text-success "
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={handleSalesReceiptSync}
                                  >
                                    Save
                                  </a>
                                </div>
                                <div className="action-item ">
                                  {editModes.qb_id && (
                                    <a
                                      className="p-0 text-muted ms-1"
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "0.875rem",
                                      }}
                                      onClick={() => {
                                        setEditModes((prev) => ({
                                          ...prev,
                                          qb_id: false,
                                        }));
                                        setValue("salesreceiptId", "");
                                      }}
                                    >
                                      Cancel
                                    </a>
                                  )}
                                </div>
                              </div>
                            </div>
                            <small className="text-muted d-block mt-1">
                              Enter to save • separate multiple IDs with comma
                            </small>
                          </div>
                        )}

                        <div
                          className="finance_Po_Qb"
                          style={{
                            display:
                              apiVendor?.qb_id && !editModes.qb_id
                                ? "flex"
                                : "none",
                          }}
                        >
                          {apiVendor?.qb_id && !editModes.qb_id
                            ? apiVendor.qb_id.split(",").map((id, i) => (
                                <span key={i} className="finance_Po_Qb_item">
                                  {id.trim()}
                                </span>
                              ))
                            : null}
                        </div>

                        {apiVendor?.qb_id?.trim() && !editModes.qb_id && (
                          <div className="d-flex align-items-center ms-2 gap-1">
                            <div className="action-item pe-3 me-2 border-end">
                              <a
                                role="button"
                                className="p-0 d-inline-flex align-items-center gap-1"
                                style={{ color: "#0d6efd" }}
                                onClick={() => {
                                  setEditModes((prev) => ({
                                    ...prev,
                                    qb_id: true,
                                  }));
                                  setValue(
                                    "salesreceiptId",
                                    apiVendor?.qb_id || "",
                                  );
                                }}
                              >
                                <IconEdit width={14} height={14} />
                                Edit
                              </a>
                            </div>
                            <Dropdown className="d-inline-block">
                              <Dropdown.Toggle
                                as="span"
                                style={{
                                  cursor: "pointer",
                                }}
                                className="p-0"
                              >
                                View
                              </Dropdown.Toggle>
                              <Dropdown.Menu
                                renderOnMount
                                popperConfig={{ strategy: "fixed" }}
                              >
                                <Dropdown.Header>
                                  Open in QuickBooks
                                </Dropdown.Header>
                                {apiVendor.qb_id
                                  .split(",")
                                  .filter(Boolean)
                                  .map((id, i) => (
                                    <Dropdown.Item
                                      key={i}
                                      href={`https://app.qbo.intuit.com/app/invoice?txnId=${id.trim()}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {id.trim()} ↗
                                    </Dropdown.Item>
                                  ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Authorize .Net</td>
                    <td>
                      <StatusBadgeDropdown
                        value={
                          apiVendor?.finance_status_authorize || "Not Created"
                        }
                        onSelect={(val) =>
                          openStatusModal({
                            value: val,
                            type: "auth",
                            order_vendor_id: null,
                            oldValue:
                              apiVendor?.finance_status_authorize ||
                              "Not Created",
                          })
                        }
                      />
                    </td>
                    <td>
                      <div class="d-flex justify-content-between align-items-center">
                        {apiVendor?.transaction_id?.trim() &&
                          !editModes.transaction_id && (
                            <div className="d-flex align-items-center ms-2 gap-1">
                              <a
                                variant="link"
                                size="sm"
                                className="p-0 d-inline-flex align-items-center gap-1"
                                style={{ color: "#0d6efd" }}
                                onClick={() => {
                                  setEditModes((prev) => ({
                                    ...prev,
                                    transaction_id: true,
                                  }));
                                  setValue(
                                    "transactionId",
                                    apiVendor?.transaction_id || "",
                                  );
                                }}
                              >
                                <IconEdit width={14} height={14} />
                                Edit here
                              </a>

                              <Dropdown className="d-inline-block">
                                <Dropdown.Toggle
                                  as="span"
                                  style={{ cursor: "pointer" }}
                                  className="p-0"
                                >
                                  View here
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Header>
                                    Open in Authorize.Net
                                  </Dropdown.Header>
                                  {apiVendor.transaction_id
                                    .split(",")
                                    .filter(Boolean)
                                    .map((id, i) => (
                                      <Dropdown.Item
                                        key={i}
                                        href={`https://account.authorize.net/ui/themes/anet/transaction-detail.aspx?transid=${id.trim()}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {id.trim()} ↗
                                      </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          )}

                        <div
                          className="finance_Po_Qb"
                          style={{
                            display:
                              apiVendor?.transaction_id &&
                              !editModes.transaction_id
                                ? "flex"
                                : "none",
                          }}
                        >
                          {apiVendor?.transaction_id &&
                          !editModes.transaction_id
                            ? apiVendor.transaction_id
                                .split(",")
                                .map((id, i) => (
                                  <span key={i} className="finance_Po_Qb_item">
                                    {id.trim()}
                                  </span>
                                ))
                            : null}
                        </div>

                        {orderId &&
                          (!apiVendor?.transaction_id ||
                            editModes.transaction_id) && (
                            <div style={{ flex: 1 }}>
                              <div className="d-flex align-items-center gap-4">
                                <Form.Control
                                  {...register("transactionId")}
                                  placeholder="e.g. 234, 245, 45"
                                  style={{ flex: "1" }}
                                  autoComplete="off"
                                  disabled={!canPay}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      handleTransactionSync();
                                    }
                                  }}
                                />

                                <div className="d-flex align-items-center ">
                                  <div className="action-item pe-2 me-2 border-end">
                                    {orderId &&
                                      canPay &&
                                      !editModes.transaction_id && (
                                        <a
                                          ole="button"
                                          className="d-inline-flex align-items-center gap-1"
                                          style={{
                                            color: "#4263eb",
                                            cursor: "pointer",
                                          }}
                                          onClick={openCardDetails}
                                        >
                                          <IconCreditCard
                                            stroke={2}
                                            size={16}
                                          />
                                          Pay via Auth.net here
                                        </a>
                                      )}
                                  </div>

                                  <div
                                    className={`action-item pe-2 me-2 ${
                                      editModes.transaction_id
                                        ? "border-end"
                                        : ""
                                    }`}
                                  >
                                    <a
                                      variant="link"
                                      className="p-0 text-success fw-medium"
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      onClick={handleTransactionSync}
                                      disabled={!canPay}
                                    >
                                      Save
                                    </a>
                                  </div>

                                  {editModes.transaction_id && (
                                    <div className="action-item pe-2 me-2 border-end">
                                      <a
                                        variant="link"
                                        className="p-0 text-muted ms-1"
                                        onClick={() => {
                                          setEditModes((prev) => ({
                                            ...prev,
                                            transaction_id: false,
                                          }));
                                          setValue("transactionId", "");
                                        }}
                                      >
                                        Cancel
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <small className="text-muted d-block mt-1">
                                Enter to save • separate multiple IDs with comma
                              </small>
                            </div>
                          )}
                      </div>

                      {/* {apiVendor?.transaction_id && (
                          <Form.Label className="me-2 text-success">
                            Transaction ID: {apiVendor.transaction_id}
                          </Form.Label>
                        )} */}
                    </td>
                  </tr>
                </>
              ) : (
                <>
                  <tr>
                    <td>Sales Receipt</td>
                    <td>
                      <StatusBadgeDropdown
                        value={apiVendor?.finance_status || "Not Created"}
                        onSelect={(val) =>
                          openStatusModal({
                            value: val,
                            type: "sr",
                            order_vendor_id: null,
                            oldValue:
                              apiVendor?.finance_status || "Not Created",
                          })
                        }
                      />
                    </td>
                    <td>
                      <div className="d-flex justify-content-between align-items-center">
                        {(!apiVendor?.qb_id || editModes.qb_id) && orderId && (
                          <div style={{ flex: 1 }}>
                            <div className="d-flex align-items-center gap-2">
                              <Form.Control
                                {...register("salesreceiptId")}
                                placeholder="e.g. 234, 245, 45"
                                className="flex-grow-1"
                                autoComplete="off"
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleSalesReceiptSync();
                                  }
                                }}
                              />

                              <div className="d-flex align-items-center ">
                                <div
                                  className={`action-item pe-2 me-2 ${
                                    editModes.qb_id ? "border-end" : ""
                                  }`}
                                >
                                  <a
                                    variant="link"
                                    className="p-0 text-success fw-medium"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={handleSalesReceiptSync}
                                  >
                                    Save
                                  </a>
                                </div>

                                <div className="action-item pe-2 me-2 ">
                                  {editModes.qb_id && (
                                    <a
                                      variant="link"
                                      className="p-0 text-muted ms-1"
                                      onClick={() => {
                                        setEditModes((prev) => ({
                                          ...prev,
                                          qb_id: false,
                                        }));
                                        setValue("salesreceiptId", "");
                                      }}
                                    >
                                      Cancel
                                    </a>
                                  )}
                                </div>
                              </div>
                            </div>
                            <small className="text-muted d-block mt-1">
                              Enter to save • separate multiple IDs with comma
                            </small>
                          </div>
                        )}

                        <div
                          className="finance_Po_Qb"
                          style={{
                            display:
                              apiVendor?.qb_id && !editModes.qb_id
                                ? "flex"
                                : "none",
                          }}
                        >
                          {apiVendor?.qb_id && !editModes.qb_id
                            ? apiVendor.qb_id.split(",").map((id, i) => (
                                <span key={i} className="finance_Po_Qb_item">
                                  {id.trim()}
                                </span>
                              ))
                            : null}
                        </div>

                        {apiVendor?.qb_id?.trim() && !editModes.qb_id && (
                          <div className="d-flex align-items-center ms-2 gap-1">
                            <div className="action-item pe-2 me-2 border-end">
                              <a
                                role="button"
                                size="sm"
                                className="p-0 d-inline-flex align-items-center gap-1"
                                onClick={() => {
                                  setEditModes((prev) => ({
                                    ...prev,
                                    qb_id: true,
                                  }));
                                  setValue(
                                    "salesreceiptId",
                                    apiVendor?.qb_id || "",
                                  );
                                }}
                              >
                                <IconEdit width={14} height={14} />
                                Edit
                              </a>
                            </div>

                            <div className="action-item ">
                              <Dropdown className="d-inline-block">
                                <Dropdown.Toggle
                                  as="span"
                                  style={{ cursor: "pointer" }}
                                >
                                  View
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Header>
                                    Open in QuickBooks
                                  </Dropdown.Header>
                                  {apiVendor.qb_id
                                    .split(",")
                                    .filter(Boolean)
                                    .map((id, i) => (
                                      <Dropdown.Item
                                        key={i}
                                        href={`https://app.qbo.intuit.com/app/salesreceipt?txnId=${id.trim()}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {id.trim()} ↗
                                      </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Authorize .Net</td>
                    <td>
                      {/* <span
                        className={`${apiVendor?.transaction_id
                          ? "badge bg-green text-green-fg"
                          : "badge bg-yellow text-yellow-fg"
                          }`}
                      >
                        <IconCircleCheckFilled size={12} />
                        {apiVendor?.transaction_id ? "Done" : "Pending"}
                      </span> */}
                      <StatusBadgeDropdown
                        value={
                          apiVendor?.finance_status_authorize || "Not Created"
                        }
                        onSelect={(val) =>
                          openStatusModal({
                            value: val,
                            type: "auth",
                            order_vendor_id: null,
                            oldValue:
                              apiVendor?.finance_status_authorize ||
                              "Not Created",
                          })
                        }
                      />
                    </td>
                    <td>
                      <div className="d-flex justify-content-between align-items-center">
                        {orderId &&
                          (!apiVendor?.transaction_id ||
                            editModes.transaction_id) && (
                            <div style={{ flex: 1 }}>
                              <div className="d-flex align-items-center gap-2">
                                <Form.Control
                                  {...register("transactionId")}
                                  placeholder="e.g. 234, 245, 45"
                                  className="flex-grow-1"
                                  autoComplete="off"
                                  disabled={!canPay}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      handleTransactionSync();
                                    }
                                  }}
                                />

                                <div className="d-flex align-items-center ">
                                  <div
                                    className={`action-item pe-2 me-2 ${
                                      editModes.transaction_id
                                        ? "border-end"
                                        : ""
                                    }`}
                                  >
                                    <a
                                      variant="link"
                                      className="p-0 text-success  "
                                      onClick={handleTransactionSync}
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      disabled={!canPay}
                                    >
                                      Save
                                    </a>
                                  </div>

                                  <div className="action-item pe-2 me-2 ">
                                    {editModes.transaction_id && (
                                      <a
                                        variant="link"
                                        className="p-0 text-muted ms-1 "
                                        onClick={() => {
                                          setEditModes((prev) => ({
                                            ...prev,
                                            transaction_id: false,
                                          }));
                                          setValue("transactionId", "");
                                        }}
                                      >
                                        Cancel
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <small className="text-muted d-block mt-1">
                                Enter to save • separate multiple IDs with comma
                              </small>
                            </div>
                          )}

                        <div
                          className="finance_Po_Qb"
                          style={{
                            display:
                              apiVendor?.transaction_id &&
                              !editModes.transaction_id
                                ? "flex"
                                : "none",
                          }}
                        >
                          {apiVendor?.transaction_id &&
                          !editModes.transaction_id
                            ? apiVendor.transaction_id
                                .split(",")
                                .map((id, i) => (
                                  <span key={i} className="finance_Po_Qb_item">
                                    {id.trim()}
                                  </span>
                                ))
                            : null}
                        </div>

                        <div className="d-flex align-items-center">
                          {orderId && canPay && !editModes.transaction_id && (
                            <div className="action-item pe-2 me-2 border-end">
                              <a
                                role="button"
                                className="d-inline-flex align-items-center gap-1"
                                style={{ color: "#4263eb", cursor: "pointer" }}
                                onClick={openCardDetails}
                              >
                                <IconCreditCard stroke={2} size={16} />
                                Pay via Auth.net
                              </a>
                            </div>
                          )}

                          {apiVendor?.transaction_id?.trim() &&
                            !editModes.transaction_id && (
                              <>
                                <div className="action-item pe-2 me-2 border-end">
                                  <a
                                    role="button"
                                    className="p-0 d-inline-flex align-items-center gap-1"
                                    onClick={() => {
                                      setEditModes((prev) => ({
                                        ...prev,
                                        transaction_id: true,
                                      }));

                                      setValue(
                                        "transactionId",
                                        apiVendor?.transaction_id || "",
                                      );
                                    }}
                                  >
                                    <IconEdit width={14} height={14} />
                                    Edit
                                  </a>
                                </div>

                                <div className="action-item">
                                  <Dropdown className="d-inline-block">
                                    <Dropdown.Toggle
                                      as="span"
                                      style={{ cursor: "pointer" }}
                                      className="p-0"
                                    >
                                      View
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                      <Dropdown.Header>
                                        Open in Authorize.Net
                                      </Dropdown.Header>

                                      {apiVendor.transaction_id
                                        .split(",")
                                        .filter(Boolean)
                                        .map((id, i) => (
                                          <Dropdown.Item
                                            key={i}
                                            href={`https://account.authorize.net/ui/themes/anet/transaction-detail.aspx?transid=${id.trim()}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {id.trim()} ↗
                                          </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </>
                            )}
                        </div>
                      </div>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </Table>
        </div>
      </Card>

      {aVendors?.length > 0 ? (
        aVendors.map((item, index) => (
          <Card className="mb-4" key={index}>
            <div className="card-header bg-white border-0 bg-light d-flex align-items-center gap-2">
              <span
                className="badge border text-secondary fw-normal"
                style={{
                  fontSize: "0.75rem",
                  padding: "4px 10px",
                  background: "#f1f3f5",
                  borderRadius: "20px",
                }}
              >
                Vendor Documents
              </span>
              <h3 className="card-title mb-0">
                <b>{item?.display_name || ""}</b>
              </h3>
            </div>
            <div class="  mail_wrapper p-0 border-0 mb-0 box-shadow-none">
              <Table className="table-bordered card-table">
                <thead>
                  <tr>
                    {/* OLD: TYPE / STATUS / ACTION */}
                    <th style={{ width: "25%" }}>DOCUMENT</th>
                    <th style={{ width: "25%" }}>STATUS</th>
                    <th style={{ width: "50%" }}>DETAILS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Purchase Order</td>
                    <td>
                      <StatusBadgeDropdown
                        value={item?.finance_status_po || "Not Created"}
                        onSelect={(val) =>
                          openStatusModal({
                            value: val,
                            type: "po",
                            order_vendor_id: item?.order_vendor_id ?? null,
                            oldValue: item?.finance_status_po || "Not Created",
                          })
                        }
                      />
                    </td>

                    <td>
                      <div className="d-flex justify-content-between align-items-center">
                        {orderId &&
                          (!item?.po_qb_id || vendorEditModes[index]?.po) && (
                            <div style={{ flex: 1 }}>
                              <div className="d-flex align-items-center gap-2">
                                <Form.Control
                                  {...register(`aVendors.${index}.poValue`)}
                                  placeholder="e.g. 234, 245, 45"
                                  className="flex-grow-1"
                                  autoComplete="off"
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      handleBillPoSync(index, "po");
                                    }
                                  }}
                                />

                                <div className="d-flex align-items-center ">
                                  <div
                                    className={`action-item pe-2 me-2 ${
                                      vendorEditModes[index]?.po
                                        ? "border-end"
                                        : ""
                                    }`}
                                  >
                                    <a
                                      role="button"
                                      className="p-0 text-success"
                                      onClick={() =>
                                        handleBillPoSync(index, "po")
                                      }
                                      style={{
                                        cursor: "pointer",
                                      }}
                                    >
                                      Save
                                    </a>
                                  </div>

                                  <div className="action-item pe-2 me-2">
                                    {vendorEditModes[index]?.po && (
                                      <a
                                        variant="link"
                                        className="p-0 text-muted ms-1"
                                        onClick={() => {
                                          setVendorEditModes((prev) => ({
                                            ...prev,
                                            [index]: {
                                              ...(prev[index] || {}),
                                              po: false,
                                            },
                                          }));
                                          setValue(
                                            `aVendors.${index}.poValue`,
                                            "",
                                          );
                                        }}
                                      >
                                        Cancel
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <small className="text-muted d-block mt-1">
                                Enter to save • separate multiple IDs with comma
                              </small>
                            </div>
                          )}
                        <div
                          className="finance_Po_Qb"
                          style={{
                            display:
                              item?.po_qb_id && !vendorEditModes[index]?.po
                                ? "flex"
                                : "none",
                          }}
                        >
                          {item?.po_qb_id && !vendorEditModes[index]?.po
                            ? item.po_qb_id.split(",").map((id, i) => (
                                <span key={i} className="finance_Po_Qb_item">
                                  {id.trim()}
                                </span>
                              ))
                            : null}
                        </div>
                        {item?.po_qb_id?.trim() &&
                          !vendorEditModes[index]?.po && (
                            <div className="d-flex align-items-center ms-2 gap-1">
                              <div className="action-item pe-2 me-2 border-end">
                                <a
                                  role="button"
                                  className="p-0 d-inline-flex align-items-center gap-1"
                                  style={{ color: "#0d6efd" }}
                                  onClick={() => {
                                    setVendorEditModes((prev) => ({
                                      ...prev,
                                      [index]: {
                                        ...(prev[index] || {}),
                                        po: true,
                                      },
                                    }));
                                    setValue(
                                      `aVendors.${index}.poValue`,
                                      item?.po_qb_id || "",
                                    );
                                  }}
                                >
                                  <IconEdit width={14} height={14} />
                                  Edit
                                </a>
                              </div>

                              <div className="action-item ">
                                <Dropdown className="d-inline-block">
                                  <Dropdown.Toggle
                                    as="span"
                                    style={{ cursor: "pointer" }}
                                  >
                                    View
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <Dropdown.Header>
                                      Open in QuickBooks
                                    </Dropdown.Header>
                                    {item.po_qb_id
                                      .split(",")
                                      .filter(Boolean)
                                      .map((id, i) => (
                                        <Dropdown.Item
                                          key={i}
                                          href={`https://app.qbo.intuit.com/app/purchaseorder?txnId=${id.trim()}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {id.trim()} ↗
                                        </Dropdown.Item>
                                      ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                          )}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Bill </td>
                    <td>
                      <StatusBadgeDropdown
                        value={item?.finance_status_bill || "Not Created"}
                        onSelect={(val) =>
                          openStatusModal({
                            value: val,
                            type: "bill",
                            order_vendor_id: item?.order_vendor_id ?? null,
                            oldValue:
                              item?.finance_status_bill || "Not Created",
                          })
                        }
                      />
                    </td>

                    <td>
                      <div className="d-flex justify-content-between align-items-center">
                        {orderId &&
                          (!item?.bill_qb_id ||
                            vendorEditModes[index]?.bill) && (
                            <div style={{ flex: 1 }}>
                              <div className="d-flex align-items-center gap-2">
                                <Form.Control
                                  {...register(`aVendors.${index}.billValue`)}
                                  placeholder="e.g. 234, 245, 45"
                                  className="flex-grow-1"
                                  autoComplete="off"
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      handleBillPoSync(index, "bill");
                                    }
                                  }}
                                />

                                <div className="d-flex align-items-center ">
                                  <div
                                    className={`action-item pe-2 me-2 ${
                                      vendorEditModes[index]?.bill
                                        ? "border-end"
                                        : ""
                                    }`}
                                  >
                                    <a
                                      variant="link"
                                      className="p-0 text-success"
                                      onClick={() =>
                                        handleBillPoSync(index, "bill")
                                      }
                                      style={{
                                        cursor: "pointer",
                                      }}
                                    >
                                      Save
                                    </a>
                                  </div>
                                  <div className="action-item pe-2 me-2">
                                    {vendorEditModes[index]?.bill && (
                                      <a
                                        variant="link"
                                        className="p-0 text-muted ms-1"
                                        onClick={() => {
                                          setVendorEditModes((prev) => ({
                                            ...prev,
                                            [index]: {
                                              ...(prev[index] || {}),
                                              bill: false,
                                            },
                                          }));
                                          setValue(
                                            `aVendors.${index}.billValue`,
                                            "",
                                          );
                                        }}
                                      >
                                        Cancel
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <small className="text-muted d-block mt-1">
                                Enter to save • separate multiple IDs with comma
                              </small>
                            </div>
                          )}
                        <div
                          className="finance_Po_Qb"
                          style={{
                            display:
                              item?.bill_qb_id && !vendorEditModes[index]?.bill
                                ? "flex"
                                : "none",
                          }}
                        >
                          {item?.bill_qb_id && !vendorEditModes[index]?.bill
                            ? item.bill_qb_id.split(",").map((id, i) => (
                                <span key={i} className="finance_Po_Qb_item">
                                  {id.trim()}
                                </span>
                              ))
                            : null}
                        </div>
                        {item?.bill_qb_id?.trim() &&
                          !vendorEditModes[index]?.bill && (
                            <div className="d-flex align-items-center ms-2 gap-1">
                              <div className="action-item pe-2 me-2 border-end">
                                <a
                                  role="button"
                                  className="p-0 d-inline-flex align-items-center gap-1"
                                  style={{ color: "#0d6efd" }}
                                  onClick={() => {
                                    setVendorEditModes((prev) => ({
                                      ...prev,
                                      [index]: {
                                        ...(prev[index] || {}),
                                        bill: true,
                                      },
                                    }));
                                    setValue(
                                      `aVendors.${index}.billValue`,
                                      item?.bill_qb_id || "",
                                    );
                                  }}
                                >
                                  <IconEdit width={14} height={14} />
                                  Edit
                                </a>
                              </div>

                              <div action-item>
                                <Dropdown className="d-inline-block">
                                  <Dropdown.Toggle
                                    as="span"
                                    style={{ cursor: "pointer" }}
                                  >
                                    View
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <Dropdown.Header>
                                      Open in QuickBooks
                                    </Dropdown.Header>
                                    {item.bill_qb_id
                                      .split(",")
                                      .filter(Boolean)
                                      .map((id, i) => (
                                        <Dropdown.Item
                                          key={i}
                                          href={`https://app.qbo.intuit.com/app/bill?txnId=${id.trim()}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {id.trim()} ↗
                                        </Dropdown.Item>
                                      ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                          )}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Card>
        ))
      ) : (
        <p>No vendors available</p>
      )}
    </>
  );
}

export default VendorForm;
